<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.2929 2.70708C13.6834 2.31655 14.3166 2.31655 14.7071 2.70708L17.2929 5.29286C17.6834 5.68339 17.6834 6.31655 17.2929 6.70708L16 7.99997L12 3.99997L13.2929 2.70708ZM11 4.99997L2 14V18H6L15 8.99997L11 4.99997Z"
  />
</svg>
